var _defs, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebstorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45.79,
    y1: -651.52,
    x2: 78.92,
    y2: -770.77,
    gradientTransform: "matrix(1 0 0 -1 0 -648.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00cdd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2086d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 56.07,
    y1: -666.71,
    x2: 112.11,
    y2: -748.88,
    gradientTransform: "matrix(1 0 0 -1 0 -648.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#00cdd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 111.71,
    y1: -676.79,
    x2: 119.07,
    y2: -702.86,
    xlinkHref: "#a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_WebStorm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M17.2 115.6L0 13.4 32 .2l20.2 12L71 2.2l38.8 15L88 128l-70.8-12.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M128 43.4L111.4 2.6 81.6 0 35.2 44.4l12.4 57.4L71 118l57-33.8L114 58l14-14.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M102.4 37.2L114 58l14-14.6L117.8 18l-15.4 19.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 24h80v80H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.6 89h30v5h-30zM70.8 62.8l4.2-5.2c3 2.4 6 4 9.8 4 3 0 4.8-1.2 4.8-3.2 0-1.8-1.2-2.8-6.6-4.2-6.6-1.8-10.8-3.6-10.8-10.2v-.2c0-6 4.8-10 11.4-10A19.58 19.58 0 0 1 95.8 38L92 43.6a15.24 15.24 0 0 0-8.4-3.2c-2.6 0-4.2 1.2-4.2 3 0 2.2 1.4 3 7 4.4 6.6 1.8 10.4 4.2 10.4 10 0 6.6-5 10.4-12 10.4a23.06 23.06 0 0 1-14-5.4M64.4 34.4l-5 19.2-5.6-19.2h-5.6l-5.6 19.2-5-19.2h-7.8l9.6 33.2h6.2L51 48.4l5.4 19.2h6.2l9.6-33.2h-7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebstorm);
export default __webpack_public_path__ + "static/media/webstorm.1b1f8e2484e3bad6e8368e32c4ea2a05.svg";
export { ForwardRef as ReactComponent };